<template>
    <section class="section_emploees">
        <div class="header_emploee">
            <p class="characteristics_title_meter">Меню</p>
            <div class="box_button_header_emploee">
                <div class="box_button_back_emploee">
                    <RouterLink
                        to="/employees"
                        class="button_standart"
                    >
                        Вернуться
                    </RouterLink>
                </div>
                <ModalHeader />
            </div>
        </div>
        <div class="section_advanced">
            <div
                v-if="loading"
                class="loading"
            >
                Загрузка...
            </div>
            <div
                v-else-if="error"
                class="error"
            >
                {{ error }}
            </div>
            <div
                v-else
                class="menu-layout"
            >
                <div
                    v-for="(row, index) in menuRows"
                    :key="index"
                    class="menu-row"
                    :class="{ 'menu-row_single': row.length === 1 }"
                >
                    <MenuSection
                        v-for="section in row"
                        :key="section.title"
                        :title="section.title"
                        :items="section.items"
                        class="menu-card"
                    />
                </div>
                <div
                    v-if="!menuRows.length"
                    class="empty-state"
                >
                    Разделы меню пока не найдены.
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { computed, ref, onMounted } from 'vue';
import ModalHeader from '@/shared/components/modal-header/ModalHeader.vue';
import {
    MenuSection,
} from './components';
import { API_ENDPOINTS } from '@/shared/constants';

const menuSections = ref([]);
const loading = ref(true);
const error = ref(null);
const sectionOrder = [
    ['Завтраки'],
    ['Первое', 'Второе'],
    ['Гарниры', 'Холодные блюда'],
    ['Выпечка десерты', 'Напитки'],
    ['Соусы'],
];

const normalizeSectionTitle = (title = '') =>
    title
        .replace(/_/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

const titleAliases = {
    'завтраки': 'Завтраки',
    'первое': 'Первое',
    'второе': 'Второе',
    'гарниры': 'Гарниры',
    'холодные блюда': 'Холодные блюда',
    'выпечка десерты': 'Выпечка десерты',
    'напитки': 'Напитки',
    'соусы': 'Соусы',
};

const menuRows = computed(() => {
    const sectionsMap = new Map(
        menuSections.value.map((section) => {
            const normalizedTitle = normalizeSectionTitle(section.title);
            const displayTitle = titleAliases[normalizedTitle] || section.title;

            return [
                displayTitle,
                {
                    title: displayTitle,
                    items: Array.isArray(section.items) ? section.items : [],
                },
            ];
        }),
    );

    return sectionOrder
        .map((row) => row
            .map((title) => sectionsMap.get(title))
            .filter(Boolean))
        .filter((row) => row.length);
});

const fetchMenu = async () => {
    try {
        const response = await fetch(API_ENDPOINTS.DINING_MENU, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        menuSections.value = data;
    } catch (e) {
        error.value = 'Ошибка при загрузке меню: ' + e.message;
        console.error('Ошибка при загрузке меню:', e);
    } finally {
        loading.value = false;
    }
};

onMounted(() => {
    fetchMenu();
});
</script>

<style scoped>
.loading {
    text-align: center;
    padding: 20px;
}

.error {
    color: red;
    text-align: center;
    padding: 20px;
}

.menu-layout {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.menu-row {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 24px;
    align-items: start;
}

.menu-row_single {
    grid-template-columns: minmax(0, 1fr);
}

.menu-card {
    min-width: 0;
}

.empty-state {
    text-align: center;
    padding: 32px 20px;
}

@media (max-width: 768px) {
    .menu-layout {
        gap: 16px;
    }

    .menu-row {
        grid-template-columns: 1fr;
        gap: 16px;
    }
}
</style>
